export interface INavGraph2SelResult {
   node1Id: string;                 // z.B. Meldung/1
   node1Group: string;              // z.B. Meldung
   edgeGroup: string;               // z.B. Meldet: im Falle BKWD -> reverse Bezeichnung aus dem Dict
   edgeDir: string;                 // Richtung: FWD oder BKWD
   nodeTypesToSelect: string[];     // zulässige Knotentypen zur Selektion
   node2Id: string;                 // z.B. KomponenteMelder/1
   node2Group: string;              // z.B. KomponenteMelder
}

export const NAV_GRAPH_SEL_RESULT_INIT: INavGraph2SelResult = {
   node1Id: '',
   node1Group: '',
   edgeGroup: '',
   edgeDir: '',
   nodeTypesToSelect: [],
   node2Id: '',                     // value: zulässige Komponente wurde selektiert, sonst ''
   node2Group: ''
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav-graph2-sel-result.interface.ts